import { jsx as o } from "react/jsx-runtime";
import { SvgIcon as m } from "../SvgIcon.js";
const d = (e) => /* @__PURE__ */ o(m, { ...e, children: /* @__PURE__ */ o(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 10c0-4.41828 3.58172-8 8-8 4.4183 0 8 3.58172 8 8 0 4.4183-3.5817 8-8 8-4.41828 0-8-3.5817-8-8Zm7.20371 4.0062h1.59999v-1.6H9.20371v1.6Zm0-3.1999h1.59999V6.00627H9.20371v4.80003Z"
  }
) });
export {
  d as BoxImportant
};
//# sourceMappingURL=BoxImportant.js.map
